import { Badge, Group, Text } from "@mantine/core";
import { type ReactNode } from "react";

/**
 * Shared rendering helper for rule-engine effect payloads. Each effect
 * payload renders a status badge (whose color flips when the effect was
 * skipped), a primary descriptor row, and an optional `(skipReason)`
 * suffix when the effect did not apply.
 *
 * Centralising this layout keeps every effect renderer consistent and
 * lets each renderer focus on just its primary descriptor `children`.
 */
interface Props {
  applied: boolean;
  appliedColor: string;
  appliedLabel: string;
  skippedLabel?: string;
  skipReason: string | null;
  children: ReactNode;
}

export function EffectRow({
  applied,
  appliedColor,
  appliedLabel,
  skippedLabel = "SKIPPED",
  skipReason,
  children,
}: Props) {
  return (
    <Group gap="xs" wrap="wrap">
      <Badge color={applied ? appliedColor : "gray"} size="xs">
        {applied ? appliedLabel : skippedLabel}
      </Badge>
      <Text size="xs">{children}</Text>
      {!applied && skipReason && (
        <Text size="xs" c="dimmed">
          ({skipReason})
        </Text>
      )}
    </Group>
  );
}
